// this script was provided by Glove.fit - DO NOT MODIFY
import { jsx as _jsx } from "react/jsx-runtime";
const GLOVE_SCRIPT = `
  (function() {
    var url = encodeURIComponent(window.location.href);
    var script = document.createElement('script');
    script.async = true;
    script.src = "https://serve.glove.fit/s/f4f9870e-ec78-11ef-89c8-0ef3cbbf7f4f/" + url;
    document.head.appendChild(script);
  })();
`;
const GloveLoader = /*#__PURE__*/ _jsx("script", {
    dangerouslySetInnerHTML: {
        __html: GLOVE_SCRIPT
    }
});
export default GloveLoader;
